export const PAYMENT_NETWORK_ICONS = {
    'americanexpress': 'fab fa-cc-amex',
    'mastercard': 'fab fa-cc-mastercard',
    'discover': 'fas fa-cc-discover',
    'visa': 'fab fa-cc-visa',
    'dinersclub': 'fas fa-cc-diners-club',
    'jcb': 'fas fa-cc-jcb',
}
